import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (removeFromListings: boolean) =>
  makeCall<undefined>(
    'DELETE',
    `/api/v2/qualification/requirements/defaults?removeFromListings=${removeFromListings.toString()}`,
  );
